module.exports = __webpack_public_path__ + "img/ssb_menu18.4161f89b.png";